// extracted by mini-css-extract-plugin
export default {"login":"Login_login__+H1JP","question":"Login_question__awHp5","link":"Login_link__4CuBe","firstname":"Login_firstname__E7xIW","password":"Login_password__1hQSz"};